import type { AppLanguage } from '@/i18n/translations';

interface LanguageFlagProps {
    className?: string;
    language: AppLanguage;
}

function LanguageFlag({ className = 'h-4 w-6', language }: LanguageFlagProps) {
    if (language === 'de') {
        return (
            <svg
                aria-hidden="true"
                className={className}
                viewBox="0 0 24 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect width="24" height="16" rx="2" fill="#000000" />
                <rect y="5.333" width="24" height="5.334" fill="#dd0000" />
                <rect y="10.667" width="24" height="5.333" fill="#ffce00" />
            </svg>
        );
    }

    if (language === 'es') {
        return (
            <svg
                aria-hidden="true"
                className={className}
                viewBox="0 0 24 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect width="24" height="16" rx="2" fill="#aa151b" />
                <rect y="4" width="24" height="8" fill="#f1bf00" />
            </svg>
        );
    }

    return (
        <svg
            aria-hidden="true"
            className={className}
            viewBox="0 0 24 16"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <clipPath id="language-flag-gb">
                    <rect width="24" height="16" rx="2" />
                </clipPath>
            </defs>
            <g clipPath="url(#language-flag-gb)">
                <rect width="24" height="16" fill="#012169" />
                <path d="M0 0l24 16M24 0L0 16" stroke="#ffffff" strokeWidth="4.5" />
                <path d="M0 0l24 16M24 0L0 16" stroke="#c8102e" strokeWidth="2.2" />
                <path d="M12 0v16M0 8h24" stroke="#ffffff" strokeWidth="7" />
                <path d="M12 0v16M0 8h24" stroke="#c8102e" strokeWidth="4" />
            </g>
        </svg>
    );
}

export default LanguageFlag;
